import { ServiceMaker, methods, services } from "@/services";

export const partnerWalletStatementBalance = (payload) =>
  ServiceMaker(
    `/wallet/v2/wallet/user-balance?amountType=${payload.amountType}`,
    methods.POST,
    services.master,
    payload.data
  );

export const partnerWalletStatementAll = (payload) =>
  ServiceMaker(
    `/wallet/v2/wallet/user-history?from=${payload.from}&to=${payload.to}&limit=${payload.limit}&page=${payload.page}`,
    methods.POST,
    services.master,
    payload.data
  );

// partner my own //

export const partnerMyOwnWalletBalance = (payload) =>
  ServiceMaker(
    `/wallet/v2/wallet/balance?amountType=${payload.amountType}`,
    methods.GET,
    services.master,
    payload
  );

export const partnerMyOwnWalletStatementAll = (payload) =>
  ServiceMaker(
    `/wallet/v2/wallet/history?from=${payload.from}&to=${payload.to}&limit=${payload.limit}&page=${payload.page}&amountTypeId=${payload.amountTypeId}`,
    methods.GET,
    services.master,
    payload
  );
